import { useState } from 'react'
import { useDebounceValue } from 'src/enviroment/hooks/useDebounceValue'
import { LayerFilters } from 'src/types/layer'

export const EMPTY_LAYER_FILTERS: LayerFilters = { countries: [], datasetIds: [], statuses: [], tenantIds: [] }

export const useLayerFilters = () => {
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState<LayerFilters>(EMPTY_LAYER_FILTERS)
  const debouncedSearch = useDebounceValue(search, 300)

  const activeFilterCount = Object.values(filters).filter((ids) => ids.length > 0).length

  return { search, setSearch, debouncedSearch, filters, setFilters, activeFilterCount }
}
